import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {AntSwitch} from './Style'



class PublicView extends React.Component {

 render() {

   return (
     <>

         <Row style={{}}>
           <Col xl={12} lg={12} md={12} sm={12} style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', padding: 3, flexDirection: 'row', marginTop: 10}}>
              <div style={{borderBottom: '2px solid orange'}}>
               <h3 style={{color: 'black', fontSize: 20, fontFamily:'Mitr, sans-sérif', }}>Public</h3>
              </div>
           </Col>
         </Row>
         <Row style={{marginTop: 10, display: 'flex', justifyContent: 'space-between'}}>
         <Col xl={3} lg={3} md={12} sm={12}>
           <div style={{display: 'flex', width: '100%', flexDirection: 'column', justifyContent: 'flex-start', margin: 5}}>
            <p style={{fontSize: 15, color: '#808080'}}>Voulez-vous publiez cette album ? </p>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <p style={{fontSize: 15, color: '#808080', margin: 10}}>Non</p>
                <AntSwitch checked={this.props.Public} onChange={() => this.props.refParent.setState({Public: !this.props.Public})} style={{marginRight: 5}}/>
                <p style={{fontSize: 15, color: '#808080', margin: 10}}>Oui</p>
              </div>
           </div>
         </Col>
         </Row>

     </>
   )
 }
}


export default PublicView;
